export default defineNuxtPlugin(async () => {
  const { initializeAuth, initFavoriteIds, initLikeIds } = useUser()

  await initializeAuth()
  await initFavoriteIds()

  // Not awaited: Nuxt mounts the app only after the plugins resolve, and the like IDs need
  // FingerprintJS plus a request. Waiting for them held back the hydration of every page by
  // 1–1.5 s, during which taps and input got no response (#296). LikeButton reads the IDs
  // reactively and updates once they arrive.
  void initLikeIds()
})
